
import axios from "axios";
import { getUrl } from "../../MIS/Global";


// Axios instance for making API calls (you can configure it as needed)
const apiClient = axios.create({
  baseURL: getUrl(),  // Replace with your API base URL
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

// Fetch all items (GET request)
export const subProduct_fetchItems = async (params) => {  
  let data={page:1,limit:1000,mpid:params?.mpid}  
  const queryParams = new URLSearchParams(data).toString();
  const response = await apiClient.get(`sub-product/?${queryParams}`);  
  return response?.data?.data;
};

export const subProduct_fetchItemPost = async (params) => {        
  const response = await apiClient.post("sub-product/", params);    
  return response.data;
  
};

// Add an item (POST request)
export const subProduct_addItem = async (newItem) => {      
  if(newItem.get("id") > 0){    
    const response = await apiClient.patch("sub-product/", newItem);  
    return response.data;
  }else{    
    delete newItem.id      
    const response = await apiClient.post("sub-product/", newItem);  
    return response.data;
  }  
};

// Delete an item (DELETE request)
export const subProduct_deleteItem = async (newItem) => {    
  const queryParams = new URLSearchParams(newItem).toString();
  const response = await apiClient.delete(`sub-product/?${queryParams}`);
  return response.data;
};
